import { mapActions } from 'vuex';

export default {
  data() {
    return {
      currentLeftSpacer: '',
      currentRightSpacer: '',
    };
  },
  methods: {
    ...mapActions('app', ['setLeftSpacer', 'setRightSpacer']),
  },
  mounted() {
    this.setLeftSpacer(this.currentLeftSpacer);
    this.setRightSpacer(this.currentRightSpacer);
  },
};